export enum FreeBuildingSummaryAccessor {
  buildingId = 'buildingId',
  buildingName = 'buildingName',
  occupiedUnits = 'occupiedUnits',
  totalUsers180d = 'totalUsers180d',
  adoptionRate = 'adoptionRate',
  monthlyActiveUsers = 'monthlyActiveUsers',
  activeRate = 'activeRate',
  eventsCount90d = 'eventsCount90d',
  rsvpsCount30d = 'rsvpsCount30d',
  commentsCount30d = 'commentsCount30d'
}

export interface IFreeBuildingSummary {
  [FreeBuildingSummaryAccessor.buildingId]: string;
  [FreeBuildingSummaryAccessor.buildingName]: string;
  [FreeBuildingSummaryAccessor.occupiedUnits]: number;
  [FreeBuildingSummaryAccessor.totalUsers180d]: number;
  [FreeBuildingSummaryAccessor.adoptionRate]: number | null;
  [FreeBuildingSummaryAccessor.monthlyActiveUsers]: number;
  [FreeBuildingSummaryAccessor.activeRate]: number | null;
  [FreeBuildingSummaryAccessor.eventsCount90d]: number;
  [FreeBuildingSummaryAccessor.rsvpsCount30d]: number;
  [FreeBuildingSummaryAccessor.commentsCount30d]: number;
}

export type EventsFilter = 'all' | 'has' | 'no';
export type CommentsFilter = 'all' | 'has' | 'no';
